import { App } from "antd";
import { useMutation } from "@tanstack/react-query";
import api from "../../utils/api";

interface ReUploadDocumentPayload {
  studentDocumentId: number;
  file: File;
  originalFileName?: string;
}

const reUploadDocument = async (payload: FormData) => {
  return (
    await api.post("/AdmissionDocument/Student/Re-UploadDocument", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  ).data as Response;
};

export const useReUploadDocumentMutation = () => {
  const { notification } = App.useApp();

  const mutation = useMutation({
    mutationFn: reUploadDocument,
  });

  const reUploadHandler = async ({
    studentDocumentId,
    file,
    originalFileName,
  }: ReUploadDocumentPayload) => {
    const formData = new FormData();
    const resolvedOriginalFileName = originalFileName || file.name;
    const fileExtension = file.name.includes(".")
      ? `.${file.name.split(".").pop()?.toLowerCase()}`
      : "";

    formData.append("StudentDocumentId", `${studentDocumentId}`);
    formData.append("OriginalFileName", resolvedOriginalFileName);
    formData.append("FileSizeInBytes", `${file.size}`);
    formData.append("FileExtension", fileExtension);
    formData.append("File", file);

    try {
      const response = await mutation.mutateAsync(formData);

      notification.success({
        message: "Success",
        description: response?.message || "Document re-uploaded successfully",
      });

      return response;
    } catch (error: any) {
      notification.error({
        message: "Error",
        description:
          error?.response?.data?.message || "Failed to re-upload document",
      });
      throw error;
    }
  };

  return {
    reUploadHandler,
    isLoading: mutation.isPending,
  };
};

export default useReUploadDocumentMutation;